import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.scss';
import App from './routes/App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <App />
);
